var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 963.78 660.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#142d66;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#0086ca;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m285.43,278.57c-28.68,0-51.93,23.24-51.93,51.93s23.25,51.92,51.93,51.92,51.93-23.24,51.93-51.92-23.25-51.93-51.93-51.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m963.58,65.57C961.53,28.8,931.08,0,894.28,0h-271.11C486.63,0,476.02,252.77,476.02,330.8s9.09,146.66,25.58,202.56c30.97,104.87,83.21,126.89,121.57,126.89h340.61V67.6l-.2-2.03Zm-139.3,455.66h-179.61l-1.29-2.99c-13.07-29.97-28.33-94.74-28.33-187.44s15.26-158.82,28.33-188.8l1.29-2.99h179.61v382.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m356.43,0h-209.85C10.58,0,0,253.57,0,331.29s9.06,146.89,25.49,202.57c30.84,104.46,82.87,126.38,121.09,126.38h209.85c38.17,0,69.23-31.06,69.23-69.23s-31.06-69.23-69.23-69.23h-188.45l-1.3-2.98c-13-29.86-28.21-95.17-28.21-187.5s15.2-159.99,28.21-189.86l1.3-2.97h188.45c38.17,0,69.23-31.06,69.23-69.23S394.61,0,356.43,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEa);
export default __webpack_public_path__ + "static/media/EA.920a37cbefecb529e780e9b105d8f0d6.svg";
export { ForwardRef as ReactComponent };